<template>
  <li
    class="mb-7 last:mb-0 py-[10px]"
    :class="{
      'border-l border-primary': theme !== 'default',
    }"
  >
    <div v-if="theme === 'default'" class="flex items-center justify-between" @click="isOpenSubs = !isOpenSubs">
      <span class="text--md uppercase">{{ category.name }}</span>
      <i-material-symbols-arrow-forward-ios
        class="rotate-90 text-[15px] text-primary"
        :class="{ 'rotate-[270deg]': isOpenSubs }"
      ></i-material-symbols-arrow-forward-ios>
    </div>
    <div v-else class="pl-[8px]">
      <router-link
        v-if="category.abstractProducts?.length"
        :to="{
          name: '/products/abstractProductCode',
          params: {
            abstractProductCode: category.abstractProducts[0].abstractProductCode,
          },
        }"
        class="text-[18px] font-normal"
        :class="{
          'text-secondary': category.code === 'FIRST_NATIONS' || category.code === 'SPECIAL_KIDS',
        }"
        @click="$emit('close-mobile-menu')"
      >
        {{ category.name }}
      </router-link>
      <span v-else class="text-[18px] font-normal text-[#CACACA]">
        {{ category.name }}
      </span>
    </div>

    <MenuSubCategoriesList
      v-if="isOpenSubs && theme === 'default'"
      :sub-categories="category.subCategories"
      :category="category"
      @close-mobile-menu="$emit('close-mobile-menu')"
    />
  </li>
</template>

<script setup>
import { ref } from "vue"
import MenuSubCategoriesList from "./MenuSubCategoriesList.vue"
import { theme } from "@/services/getSiteTheme"

defineEmits({
  "close-mobile-menu": null,
})

defineProps({
  category: {
    type: Object,
    recuired: true,
  },
})

const isOpenSubs = ref(false)
</script>

<style lang="scss" scoped></style>
